export default __webpack_public_path__ + "static/media/unknow.431b5be8.png";